module.exports = __webpack_public_path__ + "assets/images/app-settings.24c472f46addae58f37c8160ba43c548.svg";